interface PageTitleProps {
  title: string;
  subtitle: string;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

export function PageTitle({ 
  title, 
  subtitle, 
  className = '',
  titleClassName = '',
  subtitleClassName = ''
}: PageTitleProps) {
  return (
    <div className={`absolute bottom-4 right-4 z-30 text-right ${className}`}>
      <h1 className={`text-xl font-bold mb-1 ${titleClassName}`}>
        {title}
      </h1>
      <p className={`text-sm ${subtitleClassName}`}>
        {subtitle}
      </p>
    </div>
  );
}